<template>
    <v-row no-gutters>
        <v-col cols="12" class="px-8 pb-4 relative-container">
            <v-fade-transition>
                <v-row no-gutters class="alert-badge" v-if="alert.value">
                    <v-alert :type="alert.status">
                        <span v-text="alert.text"></span>
                    </v-alert>
                </v-row>
            </v-fade-transition>
            <v-row no-gutters class="py-2" v-if="studentData">
                <span class="header-title">{{  `${this.applicantInfo?.fullName?.prefix?.[`text_${this.locale}`]} ${this.applicantInfo?.fullName?.[`name_${this.locale}`]} ${this.applicantInfo?.fullName?.[`surname_${this.locale}`]}` }}</span>
            </v-row>
            <v-row no-gutters class="mb-4">
                <v-divider></v-divider>
            </v-row>
            <v-row no-gutters v-if="!actionQuery">
                <v-col cols="12">
                    <v-row no-gutters justify="space-between">
                        <v-col cols="12" lg="8">
                            <CurrentStateStepper
                                v-if="currentStep"
                                :currentStepProp="currentStep"
                                @onChangeCurrentStep="onChangeCurrentStep"
                            ></CurrentStateStepper>
                        </v-col>
                        <v-col cols="12" lg="4" class="py-4 mt-4">
                            <v-row no-gutters justify="end">
                                <div>
                                    <v-btn
                                        color="primary"
                                        text
                                        v-if="currentStep == 2"
                                        @click="downloadCandidateInfo(true)"
                                    >
                                        <v-icon left> mdi-download </v-icon>
                                        <span class="underline-text">
                                            {{ $t('message.adminPage.applicationIDcard')}}
                                        </span>
                                    </v-btn>
                                    <VueHtml2pdf
                                        :manual-pagination="true"
                                        :enable-download="true"
                                        :pdf-quality="2"
                                        pdf-orientation="portrait"
                                        ref="DownloadComp"
                                    >
                                        <section slot="pdf-content">
                                            <TicketPart
                                                v-if="
                                                    student &&
                                                    registrationFormDetail &&
                                                    organization
                                                "
                                                :registrationFormDetail="
                                                    registrationFormDetail
                                                "
                                                :student="student"
                                                :organizationDetail="
                                                    organization
                                                "
                                            />
                                        </section>
                                    </VueHtml2pdf>
                                </div>
                                <div>
                                    <v-btn
                                        color="primary"
                                        text
                                        @click="downloadCandidateInfo(false)"
                                    >
                                        <v-icon left>
                                            mdi-file-document
                                        </v-icon>
                                        <span class="underline-text">
                                            {{ $t('message.adminPage.applicantsInformation')}}
                                        </span>
                                    </v-btn>
                                </div>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="8">
                    <v-row class="mr-2">
                        <v-col cols="12">
                            <ApplicantBasicInformation
                                v-if="applicant"
                                :currentStep="currentStep"
                                :applicantInfo="applicantInfo"
                                @onAction="onAction"
                            ></ApplicantBasicInformation>
                        </v-col>
                        <v-col cols="12">
                            <ApplicantAddress
                                v-if="applicant"
                                :applicantInfo="applicantInfo"
                                :currentStep="currentStep"
                                @onAction="onAction"
                            ></ApplicantAddress>
                        </v-col>
                        <v-col cols="12">
                            <ApplicantParentInformation
                                v-if="parentInfo && applicant"
                                :currentStep="currentStep"
                                :applicantInfo="applicant"
                                :parentInformation="parentInfo"
                                @onAction="onAction"
                            ></ApplicantParentInformation>
                        </v-col>
                        <v-col cols="12">
                            <ApplicantOther
                                v-if="applicant"
                                :applicantInfo="applicant"
                                :currentStep="currentStep"
                                @onAction="onAction"
                            ></ApplicantOther>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="4">
                    <v-row no-gutters>
                        <v-col
                            cols="12"
                            v-if="applicant && checkRegisStatus && currentStep"
                        >
                            <ApplicantStatus
                                class="mb-3"
                                :applicantInfo="applicant"
                                :applicantId="applicant.id"
                                :currentStep="currentStep"
                                v-if="isFetchFile.payment"
                                :paymentEvidencesInfo="paymentEvidences"
                                @onAction="onAction"
                                @closeAlert="closeAlert"
                                @showAlert="showAlert"
                            ></ApplicantStatus>
                        </v-col>
                        <v-col
                            cols="12"
                            v-if="
                                (currentStep == 3 || currentStep == 5) &&
                                applicant
                            "
                        >
                            <ApplicantResult
                                class="mb-3"
                                :applicantInfo="applicant"
                                :currentStep="currentStep"
                                @onAction="onAction"
                            ></ApplicantResult>
                        </v-col>
                        <v-col cols="12" v-if="applicant">
                            <ApplicantDocument
                                class="mb-3"
                                :applicantInfo="applicant"
                                :currentStep="currentStep"
                                v-if="isFetchFile.document"
                                @onAction="onAction"
                                @showAlert="showAlert"
                                @loadingUpdate="loadingUpdate"
                            ></ApplicantDocument>
                        </v-col>
                        <v-col cols="12" v-if="applicant">
                            <ApplicantEvidence
                                class="mb-3"
                                :currentStep="currentStep"
                                :applicantInfo="applicant"
                                v-if="isFetchFile.payment"
                                :paymentEvidencesInfo="paymentEvidences"
                                @onAction="onAction"
                                @updateEvidenceFile="updateEvidenceFile"
                                @showAlert="showAlert"
                                @loadingUpdate="loadingUpdate"
                            ></ApplicantEvidence>
                        </v-col>
                        <v-col cols="12" v-if="applicant">
                            <ApplicantNote
                                class="mb-3"
                                :applicantInfo="applicant"
                                :currentStep="currentStep"
                                @onAction="onAction"
                                @onNoteSave="
                                    showAlert('success', $t('message.adminPage.saveSuccess'))
                                "
                            ></ApplicantNote>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters v-else>
                <v-col cols="12">
                    <v-sheet class="card-rounded">
                        <v-row no-gutters class="pa-4">
                            <v-col cols="12">
                                <v-row no-gutters align="start">
                                    <v-icon
                                        color="#255D98"
                                        small
                                        class="mr-2 mt-1"
                                    >
                                        mdi-information
                                    </v-icon>

                                    <v-col cols="11">
                                        <p
                                            class="default-text-16"
                                        >{{$t('message.adminPage.hintForEditText1')}} <br/>{{$t('message.adminPage.hintForEditText2')}} </p>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <template v-if="sectionQuery == 'basic'">
                                    <StudentHistory
                                        ref="basic"
                                        v-if="applicant"
                                        :widthProp="'100%'"
                                        :registrationState="
                                            applicant?.registrationStatus
                                        "
                                        :stepActive="getStepActive"
                                        :registrationFormDetail="
                                            applicant?.register_form
                                        "
                                        :student_id="applicant?.id"
                                        from="candidates"
                                        @loadingUpdate="loadingUpdate"
                                        @formValidate="validateStudentDetail"
                                    ></StudentHistory>
                                </template>
                                <template v-if="sectionQuery == 'parents'">
                                    <StudentParent
                                        ref="parents"
                                        v-if="applicant"
                                        :widthProp="'100%'"
                                        :registrationState="
                                            applicant?.registrationStatus
                                        "
                                        :stepActive="getStepActive"
                                        :applicantId="applicant?.id"
                                        from="candidates"
                                        @loadingUpdate="loadingUpdate"
                                        @formValidate="validateStudentParent"
                                    ></StudentParent>
                                </template>
                                <template v-if="sectionQuery == 'address'">
                                    <StudentAddress
                                        ref="address"
                                        v-if="applicant"
                                        :widthProp="'100%'"
                                        :registrationState="
                                            applicant?.registrationStatus
                                        "
                                        :stepActive="getStepActive"
                                        :applicantId="applicant?.id"
                                        from="candidates"
                                        @loadingUpdate="loadingUpdate"
                                        @formValidate="validateStudentAddressDetail"
                                    ></StudentAddress>
                                </template>
                                <template v-if="sectionQuery == 'other'">
                                    <StudentEducation
                                        ref="other"
                                        v-if="applicant"
                                        :widthProp="'100%'"
                                        :registrationState="
                                            applicant?.registrationStatus
                                        "
                                        :stepActive="getStepActive"
                                        :targetStudentYear="
                                            applicant?.grade?.value
                                        "
                                        :applicantId="applicant?.id"
                                        from="candidates"
                                        @loadingUpdate="loadingUpdate"
                                        @formValidate="validateStudentOtherDetail"
                                    ></StudentEducation>
                                </template>
                                <template v-if="sectionQuery == 'other'">
                                    <StudentHealth
                                        ref="health"
                                        v-if="applicant"
                                        :widthProp="'100%'"
                                        :registrationState="
                                            applicant?.registrationStatus
                                        "
                                        :stepActive="getStepActive"
                                        :applicantId="applicant?.id"
                                        from="candidates"
                                        @loadingUpdate="loadingUpdate"
                                    ></StudentHealth>
                                </template>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>

                <v-col cols="12">
                    <v-sheet class="card-rounded my-4 py-4 px-4" v-if="this.currentStep!='5'">
                        <v-row no-gutters justify="end">
                            <v-col cols="2">
                                <div class="mr-2">
                                    <v-btn
                                        @click="onClickCancelForm"
                                        width="100%"
                                        outlined
                                        rounded
                                        color="primary"
                                        class="
                                            default-text-prompt
                                            form-action-button
                                        "
                                        >{{ $t('message.qualifiedApplicants.cancel')}}
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    :disabled="!validateForm"
                                    width="100%"
                                    rounded
                                    color="primary"
                                    class="
                                        default-text-prompt
                                        form-action-button
                                    "
                                    @click="onClickSubmitForm"
                                    >{{ $t('message.qualifiedApplicants.save')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import CurrentStateStepper from "@/components/admin/Candidates/Applicant/CurrentStateStepper.vue";
import ApplicantBasicInformation from "@/components/admin/Candidates/Applicant/ApplicantBasicInformation.vue";
import ApplicantAddress from "@/components/admin/Candidates/Applicant/ApplicantAddress.vue";
import ApplicantParentInformation from "@/components/admin/Candidates/Applicant/ApplicantParentInformation.vue";
import ApplicantOther from "@/components/admin/Candidates/Applicant/ApplicantOther.vue";
import ApplicantStatus from "@/components/admin/Candidates/Applicant/ApplicantStatus.vue";
import ApplicantDocument from "@/components/admin/Candidates/Applicant/ApplicantDocument.vue";
import ApplicantEvidence from "@/components/admin/Candidates/Applicant/ApplicantEvidence.vue";
import ApplicantNote from "@/components/admin/Candidates/Applicant/ApplicantNote.vue";
import ApplicantResult from "@/components/admin/Candidates/Applicant/ApplicantResult.vue";

import VueHtml2pdf from "vue-html2pdf";
import TicketPart from "@/components/fileElement/TicketPart";

import StudentHistory from "@/components/formPartial/StudentHistory.vue";
import StudentAddress from "@/components/formPartial/StudentAddress.vue";
import StudentHealth from "@/components/formPartial/StudentHealth.vue";
import StudentEducation from "@/components/formPartial/StudentEducation.vue";
import StudentParent from "@/components/formPartial/StudentParent.vue";

import { formatDateTime } from "@/utils/date";
import { RegistrationStatusEnum } from "@/constants";

import * as services from "@/services";
import i18n from '@/i18n';
import { genApplicationID, genApplicationData } from "@/utils/applicant";
import { downloadEnrollmentFormPDF, getEnrollmentFormPDFBlob } from '@/utils/enrollmentFormPDF'

export default {
    components: {
        CurrentStateStepper,
        ApplicantResult,
        ApplicantBasicInformation,
        ApplicantAddress,
        ApplicantParentInformation,
        ApplicantOther,
        ApplicantStatus,
        ApplicantDocument,
        ApplicantEvidence,
        ApplicantNote,
        StudentHealth,
        StudentParent,
        StudentAddress,
        StudentHistory,
        StudentEducation,
        VueHtml2pdf,
        TicketPart,
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        yearIdParams() {
            return this.$route.params?.id;
        },
        applicantIdParam() {
            return this.$route.params?.applicantId;
        },
        gradePlanIdParam() {
            return this.$route.params?.plan_id;
        },
        actionQuery() {
            return this.$route.query?.action;
        },
        sectionQuery() {
            return this.$route.query?.section;
        },
        getStepActive() {
            if (
                this.applicant?.registrationStatus ==
                    RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL &&
                this.currentStep == 3
            )
                return 5;
            return parseInt(this.currentStep);
        },
        checkRegisStatus() {
            if (
                (this.currentStep == 1 &&
                    [
                        RegistrationStatusEnum.REGISTER,
                        RegistrationStatusEnum.PENDING_PAYMENT,
                        RegistrationStatusEnum.SUCCESSFUL_PAYMENT,
                        RegistrationStatusEnum.EXAM_UNAUTHORIZE,
                    ].includes(this.applicant?.registrationStatus)) ||
                (this.currentStep == 2 &&
                    [
                        RegistrationStatusEnum.EXAM_AUTHORIZE,
                        RegistrationStatusEnum.EXAM_AUTHORIZE_BY_SYSTEM,
                    ].includes(this.applicant?.registrationStatus)) ||
                (this.currentStep >= 3 &&
                    [
                        RegistrationStatusEnum.NOT_QUALIFY,
                        RegistrationStatusEnum.PENDING_CONFIRMATION,
                        RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION,
                        RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL,
                        RegistrationStatusEnum.REJECTION,
                        RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT,
                    ].includes(this.applicant?.registrationStatus))
            ) {
                return true;
            }
            return false;
        },
        validateForm(){
            switch(this.sectionQuery){
                case "basic": {
                    return this.form.student_detail
                }
                case "parents": {
                    return this.form.student_parent
                }
                case "address": {
                    return this.form.student_address_detail
                }
                case "other": {
                    return this.form.student_other_detail
                }
            }
            return false;
        },
        applicantInfo() {
            const studentData = this.studentData

            let applicantData = {
                id: studentData?.id,
                student_img_base64: studentData?.student_img,
                grade: studentData?.register_plan?.student_year,
                citizenId: studentData?.student_detail?.national_id,
                fullName:{
                    prefix: studentData?.student_detail?.prefix_id,
                    name_th: studentData?.student_detail?.name_th,
                    name_en: studentData?.student_detail?.name_en,
                    surname_th: studentData?.student_detail?.surname_th,
                    surname_en: studentData?.student_detail?.surname_en
                },
                track: studentData?.register_plan?.program,
                ethnicity: studentData?.student_detail?.ethnicity,
                nationality:
                    studentData?.student_detail?.nationality,
                religion: studentData?.student_detail?.religion,
                birthDate: studentData?.student_detail?.birthday,
                phoneNumber: studentData?.student_detail?.phone_number,
                email: studentData?.student_email,
                sex: studentData?.student_detail?.gender,
                talent: studentData?.student_detail?.special_skill,
                current_address: {
                    address: studentData?.student_address_detail?.current_address || null,
                    subdistrict: studentData?.student_address_detail?.current_subdistrict || null,
                    district: studentData?.student_address_detail?.current_district || null,
                    province: studentData?.student_address_detail?.current_province || null,
                    postal_code: studentData?.student_address_detail?.current_postal_code || null
                },
                national_address: {
                    address: studentData?.student_address_detail?.national_address || null,
                    subdistrict: studentData?.student_address_detail?.national_subdistrict || null,
                    district: studentData?.student_address_detail?.national_district || null,
                    province: studentData?.student_address_detail?.national_province || null,
                    postal_code: studentData?.student_address_detail?.national_postal_code || null
                },
                registrationStatus: studentData?.registration_status,

            };
            return applicantData
        },
    },
    data() {
        return {
            loading: false,
            applicant: null,
            studentData: null,
            registrationFormDetail: null,
            parentInfo: null,
            alert: {
                value: false,
                text: "",
                status: "",
            },
            currentStep: null,

            paymentEvidences: [],
            isFetchFile: {
                payment: false,
                document: false,
            },
            student: null,
            organization: null,
            studentParents: [],

            form: {
                student_detail: false,
                student_address_detail: false,
                student_parent: false,
                student_other_detail: false,
            },
        };
    },
    methods: {
        validateStudentDetail(value) {
            this.form.student_detail = value;
        },
        validateStudentOtherDetail(value) {
            this.form.student_other_detail = value;
        },
        validateStudentParent(value) {
            this.form.student_parent = value;
        },
        validateStudentAddressDetail(value) {
            this.form.student_address_detail = value;
        },
        getStudentHealthDetail(value) {
            this.student_health_detail = value;
        },
        async fetchInitStudentQuery() {
            try {
                this.loadingUpdate(1);
                const body = {
                    id: this.$route.params?.applicantId,
                    query: {
                        selects: {
                            student_detail: {
                                prefix_id: {
                                    text_th: true,
                                    text_en: true,
                                },
                                name_th: true,
                                surname_th: true,
                                name_en: true,
                                surname_en: true,
                                national_id: true,
                                student_img: true,
                            },
                            register_plan: true,
                            student_other_detail: {
                                former_school_name: true,
                                former_school_province: true,
                                former_school_district: true,
                                former_school_GPAX: true,
                                former_school_last_student_year: true,
                            },
                        },
                        relations: {
                            student_detail: {
                                prefix_id: true,
                            },
                            register_plan: {
                                program: true,
                                student_year: true,
                            },
                            student_other_detail: {
                                former_school_province: true,
                                former_school_district: true,
                                former_school_last_student_year: true,
                            },
                        },
                    },
                };
                const {
                    data: { data },
                } = await services.getStudentWithQuery(body);
                this.student = data.student;
                if (this.student.student_detail.student_img != null) {
                    let imageData = await services.getImageBase64FromUrl(
                        this.student.student_detail.student_img
                    );
                    this.student.student_detail["student_img_base64"] =
                        imageData.data.data.data;
                } else {
                    this.student.student_detail["student_img_base64"] = null;
                }

                const res = await services.getOrganization();
                this.organization = res.data.data.organization;

                this.registrationFormDetail = this.applicant?.register_form;
            } finally {
                this.loadingUpdate(-1);
            }
        },
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
        async getSectionData(section) {
            try {
                this.loadingUpdate(1);
                let step = 1;
                if (
                    this.currentStep == 3 &&
                    this.applicant?.registrationStatus ==
                        RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL
                ) {
                    step = 5;
                }
                let refBody = {};
                if (section == "basic") {
                    refBody["student_detail"] =
                        this.$refs?.[section]?._data?.student_detail;
                    refBody["student_detail"] = setStudentDetail(
                        refBody.student_detail,
                        step
                    );
                    refBody["student_parent_detail"] = {update: "current"}
                } else if (section == "address") {
                    refBody["student_address_detail"] =
                        this.$refs?.[section]?._data?.student_address_detail;
                    refBody["student_address_detail"] = setStudentAddress(
                        refBody.student_address_detail,
                        step
                    );
                    refBody["student_parent_detail"] = {update: "current"}
                } else if (section == "other") {
                    refBody["student_other_detail"] =
                        this.$refs?.[section]?._data?.student_other_detail;
                    if (step == 5) {
                        refBody.student_other_detail = {
                            ...refBody.student_other_detail,
                            ...this.$refs["health"]?._data,
                        };
                    }
                    refBody["student_parent_detail"] = {update: "current"}
                    refBody["student_other_detail"] = setStudentOtherDetail(
                        refBody.student_other_detail,
                        step
                    );
                    refBody["student_parent_detail"] = {update: "current"}
                } else if (section == "parents") {
                    refBody["student_parent"] = this.$refs?.[section]?._data;
                    refBody["student_parent_address"] = {
                        father: {},
                        mother: {},
                        guardian: {},
                    };
                    if (step == 5) {
                        const {
                            data: { data },
                        } = await services.getStudentWithQuery({
                            id: this.$route.params?.applicantId,
                            query: {
                                relations: {
                                    student_address_detail: {
                                        national_province: true,
                                        national_district: true,
                                        national_subdistrict: true,
                                        current_province: true,
                                        current_district: true,
                                        current_subdistrict: true,
                                    },
                                },
                            },
                        });
                        const student_address =
                            data.student.student_address_detail;
                        const student_parent = this.$refs?.parents;

                        if (!student_parent?._data?.father?.is_same_student_address) {
                            const address =
                                student_parent?.$refs?.fatherAddress?._data
                                    ?.parentAddress;
                            refBody.student_parent_address.father = {
                                ...refBody.student_parent_address.father,
                                ...address,
                                is_same_student_address: false,
                            };
                        } else {
                            refBody.student_parent_address.father = {
                                address: student_address.current_address,
                                province:
                                    student_address.current_province.value,
                                district:
                                    student_address.current_district.value,
                                subdistrict:
                                    student_address.current_subdistrict.value,
                                postal_code:
                                    student_address.current_postal_code,
                                is_same_student_address: true,
                            };
                        }
                        if (!student_parent?._data?.mother?.is_same_student_address) {
                            const address =
                                student_parent?.$refs?.motherAddress?._data
                                    ?.parentAddress;
                            refBody.student_parent_address.mother = {
                                ...refBody.student_parent_address.mother,
                                ...address,
                                is_same_student_address: false,
                            };
                        } else {
                            refBody.student_parent_address.mother = {
                                address: student_address.current_address,
                                province:
                                    student_address.current_province.value,
                                district:
                                    student_address.current_district.value,
                                subdistrict:
                                    student_address.current_subdistrict.value,
                                postal_code:
                                    student_address.current_postal_code,
                                is_same_student_address: true,
                            };
                        }
                        if (!student_parent?._data?.guardian?.is_same_student_address) {
                            const address =
                                student_parent?.$refs?.guardianAddress?._data
                                    .parentAddress;
                            refBody.student_parent_address.guardian = {
                                ...refBody.student_parent_address.guardian,
                                ...address,
                                is_same_student_address: false,
                            };
                        } else {
                            refBody.student_parent_address.guardian = {
                                address: student_address.current_address,
                                province:
                                    student_address.current_province.value,
                                district:
                                    student_address.current_district.value,
                                subdistrict:
                                    student_address.current_subdistrict.value,
                                postal_code:
                                    student_address.current_postal_code,
                                is_same_student_address: true,
                            };
                        }

                    }
                    const hasFather = refBody.student_parent.hasFather;
                    const hasMother = refBody.student_parent.hasMother;
                    const toggleDisableGuardian =
                        refBody.student_parent.toggleDisableGuardian;
                    refBody = setStudentParent(
                        refBody.student_parent,
                        refBody.student_parent_address,
                        step
                    );

                    if (!hasFather) {
                        delete refBody.father;
                    }
                    if (!hasMother) {
                        delete refBody.mother;
                    }
                    if (toggleDisableGuardian) {
                        delete refBody.guardian;
                    }
                    delete refBody.student_parent_address;
                    delete refBody.student_parent;
                }

                return refBody;
            } finally {
                this.loadingUpdate(-1);
            }
        },
        onClickCancelForm() {
            let currentPath = this.$route.path;
            let defaultPath = currentPath.split("?")[0];
            this.$router.push(defaultPath);
        },
        async onClickSubmitForm() {
            let currentPath = this.$route.path;
            let defaultPath = currentPath.split("?")[0];
            const params = this.$route.query;
            const body = await this.getSectionData(params?.section);

            await this.updateStudentDate(body, params);
            this.$router.push(defaultPath);
            this.showAlert("success", this.$i18n.t('message.adminPage.saveSuccess'));
            setTimeout(() => {
                location.reload();
            }, 3000);
        },
        async updateStudentDate(body, params) {
            try {
                this.loadingUpdate(1);
                if(params?.section == "basic"){
                    // upload student picture
                    const student_detail = body.student_detail
                    if(student_detail.student_img != null){
                        await services.uploadStudentPicture(student_detail.student_img.body, {
                            module: student_detail.student_img.module,
                            fileName: student_detail.student_img.fileName,
                            student_id: student_detail.student_img.student_id,
                        });
                    }
                }
                body["registration_status"] = "current";
                body["step"] = this.getStepActive;
                const res = await services.updateStudentApplicationForm(
                    body,
                    this.applicant.id
                );
                if (res.status == 200) {
                    setTimeout(() => {
                        location.reload();
                    }, 3000);
                }
            } finally {
                this.loadingUpdate(-1);
            }
        },
        updateEvidenceFile(value){
            this.paymentEvidences = value
        },
        async fetchDataFromDb() {
            try {
                this.loadingUpdate(1);
                const res = await services.getStudentWithQuery({
                    id: this.$route.params?.applicantId,
                    query: {
                        selects: {
                            student_detail: true,
                            student_other_detail: true,
                            student_address_detail: true,
                            student_parent_detail: true,
                            register_plan: true,
                            register_form: {
                                id: true,
                            },
                        },
                        relations: {
                            student_address_detail: {
                                national_province: true,
                                national_district: true,
                                national_subdistrict: true,
                                current_province: true,
                                current_district: true,
                                current_subdistrict: true,
                            },
                            student_parent_detail: true,
                            student_detail: {
                                ethnicity: true,
                                nationality: true,
                                religion: true,
                                prefix_id: true,
                            },
                            student_other_detail: {
                                former_school_province: true,
                                former_school_district: true,
                                former_school_last_student_year: true,
                            },
                            register_plan: {
                                program: true,
                                student_year: true,
                            },
                            register_form: true,
                        },
                    },
                });

                const studentData = res?.data?.data?.student;
                let student_img = null;
                if (studentData?.student_detail?.student_img) {
                    let imageData = await services.getImageBase64FromUrl(
                        studentData?.student_detail?.student_img
                    );
                    student_img = imageData.data.data.data;
                    studentData['student_img'] = student_img
                }
                const register_form = await services.getRegistrationFormById(
                    studentData?.register_form?.id
                );
                studentData['register_form'] = register_form.data.data.registration_form
                if (studentData === null) {
                    return null;
                }

                let parentData = [];
                if (studentData.student_parent_detail?.id != undefined) {
                    const resParent = await services.getStudentParents(
                        studentData.student_parent_detail.id
                    );
                    parentData = resParent?.data?.data?.student_parents;
                }

                this.studentParents = parentData
                this.studentData = studentData
                this.applicant = {
                    id: studentData?.id,
                    student_img_base64: student_img,
                    grade: studentData?.register_plan?.student_year,
                    citizenId: studentData?.student_detail?.national_id,
                    fullName: `${studentData?.student_detail?.prefix_id?.text_th} ${studentData?.student_detail?.name_th} ${studentData?.student_detail?.surname_th}`,
                    track: studentData?.register_plan?.program?.program_name_th,
                    ethnicity: studentData?.student_detail?.ethnicity?.name_th,
                    nationality:
                        studentData?.student_detail?.nationality?.name_th,
                    religion: studentData?.student_detail?.religion?.name_th,
                    birthDate: this.birthdayDate(
                        studentData?.student_detail?.birthday
                    ),
                    phoneNumber: studentData?.student_detail?.phone_number,
                    email: studentData?.student_email,
                    sex:
                        studentData?.student_detail?.gender ||
                        null,
                    talent: studentData?.student_detail?.special_skill,
                    current_address: {
                        address: studentData?.student_address_detail?.current_address || null,
                        moo: studentData?.student_address_detail?.current_moo || null,
                        soi: studentData?.student_address_detail?.current_soi || null,
                        road: studentData?.student_address_detail?.current_road || null,
                        subdistrict: studentData?.student_address_detail?.current_subdistrict?.name_th || null,
                        district: studentData?.student_address_detail?.current_district?.name_th || null,
                        province: studentData?.student_address_detail?.current_province || null,
                        postal_code: studentData.student_address_detail?.current_postal_code || null
                    },
                    national_address: {
                        address: studentData?.student_address_detail?.national_address || null,
                        moo: studentData?.student_address_detail?.national_moo || null,
                        soi: studentData?.student_address_detail?.national_soi || null,
                        road: studentData?.student_address_detail?.national_road || null,
                        subdistrict: studentData?.student_address_detail?.national_subdistrict?.name_th || null,
                        district: studentData?.student_address_detail?.national_district?.name_th || null,
                        province: studentData?.student_address_detail?.national_province || null,
                        postal_code: studentData?.student_address_detail?.national_postal_code || null
                    },
                    oldSchool:
                        studentData?.student_other_detail?.former_school_name,
                    GPAX: studentData?.student_other_detail?.former_school_GPAX,
                    graduatedLevel:
                        studentData?.student_other_detail
                            ?.former_school_last_student_year,
                    healthInfo: {
                        weight: studentData?.student_other_detail?.weight,
                        height: studentData?.student_other_detail?.height,
                        bloodGroup:
                            studentData?.student_other_detail?.blood_type,
                        congenitalDisease:
                            studentData?.student_detail?.medical_condition,
                        drugAllergy:
                            studentData?.student_other_detail?.drug_allergy,
                        regularMedication:
                            studentData?.student_other_detail
                                ?.regular_medication,
                        note: studentData?.student_other_detail?.note,
                        notation: studentData?.student_other_detail?.notation,
                    },
                    register_form: register_form?.data?.data?.registration_form,
                    registrationStatus: studentData?.registration_status,
                    result: {
                        totalScore: studentData?.score,
                        resultType: studentData?.result_type || "",
                        rankNumber: studentData?.reserved_no,
                        enrollmentDate:
                            studentData?.enrollment_confirmation_date || null,
                    },
                    files: [
                    ],
                    filesDocument: [
                    ],
                };
                const parentType = {
                    FATHER: {
                        title: 'message.adminPage.parentInfo.father',
                        color: "#255D98",
                        isFather: true,
                        isParent: false,
                        bg: "rgba(37, 93, 152, 0.3)",
                        border: "rgba(37, 93, 152, 1.0)",
                    },
                    MOTHER: {
                        title: 'message.adminPage.parentInfo.mother',
                        color: "#F1996D",
                        isFather: false,
                        isParent: false,
                        bg: "rgba(241, 153, 109, 0.3)",
                        border: "rgba(241, 153, 109, 1.0)",
                    },
                    GUARDIAN: {
                        title: 'message.adminPage.parentInfo.guardian',
                        color: "#FFC166",
                        isFather: false,
                        isParent: true,
                        bg: "rgba(255, 193, 102, 0.3)",
                        border: "rgba(255, 193, 102, 1.0)",
                    },
                };

                let guardian = null
                this.parentInfo = parentData.map((p) => {
                    if(p.is_guardian && p.parent_type != "GUARDIAN")
                        guardian = p
                    return {
                        title: parentType[p?.parent_type]?.title,
                        fullName:{
                            prefix: p?.prefix_id,
                            prefix_th: p?.prefix_th,
                            prefix_en: p?.prefix_en,
                            name_th: p?.name_th,
                            name_en: p?.name_en,
                            surname_th: p?.surname_th,
                            surname_en: p?.surname_en
                        },
                        phoneNumber: p?.phone_number,
                        isFather: parentType[p?.parent_type]?.isFather,
                        isParent: parentType[p?.parent_type]?.isParent,
                        color: parentType[p?.parent_type]?.color,
                        bg: parentType[p?.parent_type]?.bg,
                        border: parentType[p?.parent_type]?.border,
                    };
                });

                if(guardian){
                    this.parentInfo.push({
                        title: 'message.adminPage.parentInfo.guardian',
                        fullName:{
                            prefix: guardian?.prefix_id,
                            prefix_th: guardian?.prefix_th,
                            prefix_en: guardian?.prefix_en,
                            name_th: guardian?.name_th,
                            name_en: guardian?.name_en,
                            surname_th: guardian?.surname_th,
                            surname_en: guardian?.surname_en
                        },
                        phoneNumber: guardian?.phone_number,
                        isFather: parentType[guardian?.parent_type]?.isFather,
                        isParent: parentType[guardian?.parent_type]?.isParent,
                        color: "#FFC166",
                        bg: "rgba(255, 193, 102, 0.3)",
                        border: "rgba(255, 193, 102, 1.0)"
                    })
                }

                this.currentStep = this.checkCurrentStepFromStudent(
                    this.applicant?.registrationStatus,
                    this.applicant?.register_form?.fee
                );

                await this.fetchInitStudentQuery();
                await this.fetchDocumentEvidences();
            } finally {
                this.loadingUpdate(-1);
            }
        },
        async fetchDocumentEvidences() {
            try {
                this.loadingUpdate(1);
                const {
                    data: {
                        data: { paymentDocument },
                    },
                } = await services.getPaymentDocument(
                    this.$route.params?.applicantId
                );

                this.paymentEvidences = paymentDocument;
                for (let i = 0; i < this.paymentEvidences.length; i++) {
                    let name = null
                    if(this.paymentEvidences[i].document_name != null || this.paymentEvidences[i].document_name != undefined )
                        name = this.paymentEvidences[i].document_name
                    else
                        name = this.paymentEvidences[i].payment_evidence
                    this.applicant.files.push({
                        id: this.paymentEvidences[i].file_id || null,
                        name: name,
                        url: this.paymentEvidences[i].payment_evidence,
                        icon: "mdi-paperclip",
                        color: "#D29F69",
                        ableToEdit: !this.paymentEvidences[i].is_student_upload,
                    });
                }
                this.isFetchFile.payment = true;

                const {
                    data: {
                        data: { registration_document },
                    },
                } = await services.getRegistrationDocument(
                    this.$route.params?.applicantId
                );
                for (let i = 0; i < registration_document.length; i++) {
                    this.applicant.filesDocument.push({
                        id: registration_document[i].id,
                        name: registration_document[i].document_name,
                        url: registration_document[i].document_url,
                        icon: "mdi-paperclip",
                        color: "#F1996D",
                        ableToEdit: true,
                    });
                }
                this.isFetchFile.document = true;
            } finally {
                this.loadingUpdate(-1);
            }
        },

        checkConditionRegistrationStatus() {
            if (this.applicant == null) {
                return null;
            }
            if (
                this.currentStep == "1" &&
                this.applicant.registrationStatus ==
                    RegistrationStatusEnum.PENDING_PAYMENT
            ) {
                // TODO: save to database
                this.applicant.registrationStatus =
                    RegistrationStatusEnum.SUCCESSFUL_PAYMENT;
                this.applicant.registration_status =
                    RegistrationStatusEnum.EXAM_AUTHORIZE;
            }
        },
        checkCurrentStepFromStudent(registrationStatus, fee) {
            if (fee == 0) {
                if (
                    [
                        RegistrationStatusEnum.REGISTER,
                        RegistrationStatusEnum.PENDING_PAYMENT,
                        RegistrationStatusEnum.SUCCESSFUL_PAYMENT,
                        RegistrationStatusEnum.EXAM_UNAUTHORIZE,
                    ].includes(registrationStatus)
                ) {
                    return "1";
                } else if (
                    [
                        RegistrationStatusEnum.EXAM_AUTHORIZE,
                        RegistrationStatusEnum.EXAM_AUTHORIZE_BY_SYSTEM,
                    ].includes(registrationStatus)
                ) {
                    return "2";
                } else if (
                    registrationStatus ==
                    RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT
                ) {
                    return "5";
                } else {
                    return "3";
                }
            } else {
                if (
                    [
                        RegistrationStatusEnum.REGISTER,
                        RegistrationStatusEnum.PENDING_PAYMENT,
                        RegistrationStatusEnum.SUCCESSFUL_PAYMENT,
                        RegistrationStatusEnum.EXAM_UNAUTHORIZE,
                    ].includes(registrationStatus)
                ) {
                    return "1";
                } else if (
                    [
                        RegistrationStatusEnum.EXAM_AUTHORIZE,
                        RegistrationStatusEnum.EXAM_AUTHORIZE_BY_SYSTEM,
                    ].includes(registrationStatus)
                ) {
                    return "2";
                } else if (
                    registrationStatus ==
                    RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT
                ) {
                    return "5";
                } else {
                    return "3";
                }
            }
        },
        birthdayDate(date) {
            let newDate = Date.parse(date);
            if (newDate) return formatDateTime(newDate);
            else return "";
        },

        showAlert(status, text) {
            this.alert.value = true;
            this.alert.text = text;
            this.alert.status = status;
            setTimeout(() => {
                this.closeAlert();
            }, 3000);
        },
        closeAlert() {
            this.alert.value = false;
        },
        onChangeCurrentStep(step) {
            this.currentStep = step;
        },
        async download() {
            this.$refs?.DownloadComp?.generatePdf();
        },
        async downloadCandidateInfo(isShowTicket) {
            try {
                this.$emit('loadingUpdate',1)
                const applicationID = genApplicationID(this.registrationFormDetail?.grade_level, this.student?.index_number)
                const filename = `enrollment_form_${applicationID}.pdf`
                downloadEnrollmentFormPDF(genApplicationData(this.studentData, this.studentParents, isShowTicket), filename)
            } catch (error) {
                console.error('Error downloading PDF:', error)
                this.$toast.error(this.$t('message.common.downloadError'));
            } finally {
                this.$emit('loadingUpdate',-1)
            }
        },
        async downloadExcel() {
            try {
                this.loadingUpdate(1);
                const student_id = this.$route.params?.applicantId;
                const { data } = await services.exportExcelApplicant(student_id, `student_report_${student_id}`);
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
                });
                const downloadUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.target = "_blank";
                a.href = downloadUrl;
                a.download = `student_report_${student_id}.xlsx`;
                document.body.appendChild(a);
                a.click();
            } finally {
                this.loadingUpdate(-1);
            }
        },
        onAction(action, section) {
            if (action == null && section == null) {
                this.$router.push(
                    `/registration/calendar/${this.yearIdParams}/grade-plans/${this.gradePlanIdParam}/applicant/${this.applicantIdParam}`
                );
            } else {
                this.$router.push(
                    `/registration/calendar/${this.yearIdParams}/grade-plans/${this.gradePlanIdParam}/applicant/${this.applicantIdParam}?action=${action}&section=${section}`
                );
            }
        }
    },
    mounted() {
        this.fetchDataFromDb();
    },
};

const setStudentDetail = (student_detail_form, step) => {
    const student_detail = {
        special_skill: student_detail_form.special_skill,
        national_id: student_detail_form.national_id,
        gender: student_detail_form.gender,
        prefix_id: student_detail_form.prefix_th,
        name_th: student_detail_form.name_th,
        name_en: student_detail_form.name_en,
        surname_th: student_detail_form.surname_th,
        surname_en: student_detail_form.surname_en,
        birthday: student_detail_form.birthday,
        phone_number: student_detail_form.phone_number,

        ethnicity: student_detail_form.ethnicity,
        nationality: student_detail_form.nationality,
        religion: student_detail_form.religion,
        student_year: student_detail_form.student_year,
        program: student_detail_form.program,
        register_plan_id: student_detail_form.register_plan_id,
        student_img: student_detail_form.student_img_body
    };
    if (step == 5) {
        student_detail.nickname_th = student_detail_form.nickname_th;
        student_detail.nickname_en = student_detail_form.nickname_en;
        student_detail.relatives_count = Number(
            student_detail_form.relatives_count
        );
        student_detail.relatives_index = Number(
            student_detail_form.relatives_index
        );
        student_detail.birth_hospital = student_detail_form.birth_hospital;
        if (
            student_detail.relatives_count == 0 &&
            student_detail.relatives_index == 0
        ) {
            student_detail.has_relatives = false;
        } else {
            student_detail.has_relatives = true;
        }
        student_detail.hospital_province =
            student_detail_form.hospital_province;
    }

    return student_detail;
};

const setStudentOtherDetail = (student_other_detail_form, step) => {
    let student_other_detail = {
        former_school_name: student_other_detail_form.former_school_name,
        former_school_province:
            student_other_detail_form.former_school_province,
        former_school_district:
            student_other_detail_form.former_school_district,
        former_school_GPAX: student_other_detail_form.former_school_GPAX,
        former_school_last_student_year:
            student_other_detail_form.former_school_last_student_year,
        transfer_reason:
            student_other_detail_form.transfer_reason || null,
    };
    if (step == 5) {
        const student_other_detail_step5 = {
            weight: student_other_detail_form.weight,
            height: student_other_detail_form.height,
            blood_type: student_other_detail_form.blood_type,
            medical_condition: student_other_detail_form.medical_condition,
            drug_allergy: student_other_detail_form.drug_allergy,
            regular_medication: student_other_detail_form.regular_medication,
            note: student_other_detail_form.note,
        };

        student_other_detail = {
            ...student_other_detail,
            ...student_other_detail_step5,
        };
    }
    return student_other_detail;
};

const setStudentAddress = (student_address_detail_form, step) => {
    const student_address_detail = {
        national_address: student_address_detail_form.national_address,
        national_moo: student_address_detail_form.national_moo,
        national_soi: student_address_detail_form.national_soi,
        national_road: student_address_detail_form.national_road,
        national_province: student_address_detail_form.national_province,
        national_district: student_address_detail_form.national_district,
        national_subdistrict: student_address_detail_form.national_subdistrict,
        national_postal_code: student_address_detail_form.national_postal_code,
    };
    if (step == 5) {
        student_address_detail.current_address =
            student_address_detail_form.current_address;
        student_address_detail.current_moo =
            student_address_detail_form.current_moo;
        student_address_detail.current_soi =
            student_address_detail_form.current_soi;
        student_address_detail.current_road =
            student_address_detail_form.current_road;
        student_address_detail.current_province =
            student_address_detail_form.current_province;
        student_address_detail.current_district =
            student_address_detail_form.current_district;
        student_address_detail.current_subdistrict =
            student_address_detail_form.current_subdistrict;
        student_address_detail.current_postal_code =
            student_address_detail_form.current_postal_code;
        student_address_detail.accommodation_type =
            student_address_detail_form.accommodation_type;
        student_address_detail.distance_home_to_school = Number(
            student_address_detail_form.distance_home_to_school
        );
        student_address_detail.transportation_type =
            student_address_detail_form.transportation_type;
        student_address_detail.is_same_address =
            student_address_detail_form.is_same_address;
    }
    return student_address_detail;
};

const setStudentParent = (
    student_parent_form,
    student_parent_address,
    step
) => {
    const mother = student_parent_form.mother;
    const father = student_parent_form.father;
    const guardian = student_parent_form.guardian;

    const student_parent = {
        father: {
            prefix_id: father.prefix_id,
            name_th: father.name_th,
            name_en: father.name_en,
            surname_th: father.surname_th,
            surname_en: father.surname_en,
            phone_number: father.phone_number,
            career: father.career,
            position: father.position,
            work_place: father.work_place,
            prefix_th: father.prefix_th,
            prefix_en: father.prefix_en,
            is_guardian: student_parent_form.checkFather,
        },
        mother: {
            prefix_id: mother.prefix_id,
            name_th: mother.name_th,
            name_en: mother.name_en,
            surname_th: mother.surname_th,
            surname_en: mother.surname_en,
            phone_number: mother.phone_number,
            career: mother.career,
            position: mother.position,
            work_place: mother.work_place,
            prefix_th: mother.prefix_th,
            prefix_en: mother.prefix_en,
            is_guardian: student_parent_form.checkMother,
        },
        guardian: {
            prefix_id: guardian.prefix_id,
            name_th: guardian.name_th,
            name_en: guardian.name_en,
            surname_th: guardian.surname_th,
            surname_en: guardian.surname_en,
            phone_number: guardian.phone_number,
            career: guardian.career,
            position: guardian.position,
            work_place: guardian.work_place,
            prefix_th: guardian.prefix_th,
            prefix_en: guardian.prefix_en,
            is_guardian: true,
        },
    };

    student_parent.student_parent_detail = {
        family_status: student_parent_form.student_parent_detail.family_status,
        is_siblings_study_together: student_parent_form.student_parent_detail.is_siblings_study_together,
        siblings_name: student_parent_form.student_parent_detail.siblings_name,
        siblings_surname: student_parent_form.student_parent_detail.siblings_surname,
        siblings_grade: student_parent_form.student_parent_detail.siblings_grade,
        siblings_house: student_parent_form.student_parent_detail.siblings_house,
        update: "new"
    };

    if (step == 5) {
        // detail

        const father_step5 = {
            email: father.email,
            salary: father.salary,
            parent_type: father.parent_type,
            ...student_parent_address.father,
        };
        const mother_step5 = {
            email: mother.email,
            salary: mother.salary,
            parent_type: mother.parent_type,
            ...student_parent_address.mother,
        };
        const guardian_step5 = {
            email: guardian.email,
            salary: guardian.salary,
            parent_type: guardian.parent_type,
            ...student_parent_address.guardian,
        };
        // address

        student_parent.mother = { ...student_parent.mother, ...mother_step5 };
        student_parent.father = { ...student_parent.father, ...father_step5 };
        student_parent.guardian = {
            ...student_parent.guardian,
            ...guardian_step5,
        };

        student_parent.student_parent_detail = { ...student_parent.student_parent_detail,
            family_status: student_parent_form.student_parent_detail.family_status,
            is_siblings_study_together: student_parent_form.student_parent_detail.is_siblings_study_together,
            siblings_name: student_parent_form.student_parent_detail.siblings_name,
            siblings_surname: student_parent_form.student_parent_detail.siblings_surname,
            siblings_grade: student_parent_form.student_parent_detail.siblings_grade,
            siblings_house: student_parent_form.student_parent_detail.siblings_house,
            student_allowance_by: student_parent_form.student_parent_detail.student_allowance_by,
        };
    }
    return student_parent;
};
</script>

<style scoped lang="scss">
.form-action-button {
    /* Glow/Primary */
    box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
    border-radius: 40px;
}
.relative-container {
    position: relative;
}
.alert-badge {
    z-index: 10;
    position: fixed;
    right: 0;
    bottom: 0;
    margin: 10px;
}
.header-title {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 34px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.default-text-16 {
    font-family: "Sarabun";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #37323c;
}
.underline-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    text-decoration-line: underline;
}

.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text-prompt {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
